import {
  CategoryType,
  type ListInsightsQueryVariables,
  PartyRole,
  useListInsightsQuery,
} from "@digits-graphql/frontend/graphql-bearer"
import { useIsShareUser } from "src/frontend/hooks/useObjectSharingState"

export const SUPPORTED_INSIGHT_CATEGORY_TYPES = [
  CategoryType.Expenses,
  CategoryType.CostOfGoodsSold,
  CategoryType.Income,
]
export const SUPPORTED_INSIGHT_PARTY_ROLES = [
  PartyRole.EntityVendorRole,
  PartyRole.EntityCustomerRole,
]

export function useListInsights(variables: ListInsightsQueryVariables, skip?: boolean) {
  const isShareUser = useIsShareUser()

  return useListInsightsQuery({
    variables,
    skip: isShareUser || skip,
  })
}
